import appCheckpoint from '@/apps/payments/resources/checkpoint';

export default {
  exists: (...args) => appCheckpoint.exists(...args),
  existsInCompany: (...args) => appCheckpoint.existsInCompany(...args),
  create: (...args) => appCheckpoint.create(...args)
};
